module.exports = __webpack_public_path__ + "img/free_practice.2c58d8cd.png";